import { useTranslation } from 'react-i18next';
import { getCurrency } from '@/app/utils/currency';
import { CreateDonationRequestCurrencyEnum } from '@/app/api';

export const useCurrencyTranslation = () => {
  const { t } = useTranslation();

  const currency = getCurrency();

  switch (currency) {
    case CreateDonationRequestCurrencyEnum.Czk:
      return t('enums.currency.CZK');

    case CreateDonationRequestCurrencyEnum.Eur:
      return t('enums.currency.EUR');

    default:
      return '-';
  }
};
